import React from 'react';
import {Row, Col, Modal} from 'react-bootstrap';
import ItemUnitOrVariants from './ItemUnitOrVariants';
import JoinScheduleSelector from '../../containers/join/JoinScheduleSelector';
import {translate} from '../../i18n/translate';
import {setNoItemImage} from '../../common/utils';
import styles from "../../css/itemDetails.less";

class ItemDetails extends React.Component {
    getProducerLink = (item) => {
        if(item.producer.link) {
            return <a className="producer-link" href={item.producer.link} target="_blank">{translate("Learn More")}</a>;
        }
    };

    getMobileViewDetails = () => {
        const item = this.props.item;
        return (
            <div className="mobile-details-full">
                <div className="mobile-details scroll">
                    <Row>
                        <div className="item-title" id="modal-item-title">{this.props.item.title}</div>
                    </Row>
                    <Row>
                        <div className="producer-title" id="modal-producer-title">{this.props.item.producerTitle}</div>
                    </Row>
                    <Row className="price-and-buttons">
                        <ItemUnitOrVariants item={this.props.item}
                                            clientViewPort={this.props.clientViewPort}
                                            staticData = {this.props.staticData}
                                            forDetails={true}
                                            schedules={this.getSchedules()}
                                            variantsPubSub={this.props.variantsPubSub}
                                            isJoinFlow = {this.props.isJoinFlow}
                                            isFarmSeasonal={this.props.isFarmSeasonal}
                                            pickupSite={this.props.pickupSite}
                                            hideQuantityUpdater={true}/>
                    </Row>
                    <Row>
                      {this.props.item.label && <div className="item-label">{this.props.item.label}</div>}
                        <Col sm={12}><img src={this.props.item.imageUrl} onError={setNoItemImage}/></Col>
                    </Row>
                    <Row>
                        <Col sm={12} className="title">{translate("Product Details")}</Col>
                    </Row>
                    <Row>
                        <Col sm={12} className="description" id="modal-description" dangerouslySetInnerHTML={{__html: item.description}}/>
                    </Row>

                    {(() => {
                        if (this.props.staticData.hideProducer) {
                            return null;
                        }
                        if (item.producer.imageUrl && item.producer.imageUrl !== "http://"){
                            return (
                                <div>
                                    <Row className="producer">
                                        <Col sm={12} className="title">{translate("About the producer")}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className="producer-img"><img src={item.producer.imageUrl} className="producer-img-src" onError={(event)=>event.target.style.display='none'}/></Col>
                                        <Col sm={12} className="description" id="modal-producer-description">
                                            <span dangerouslySetInnerHTML={{__html: item.producer.description}}/>
                                            {this.getProducerLink(item)}
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                        return (
                            <div>
                                <Row className="producer">
                                    <Col sm={12} className="title">{translate("About the producer")}</Col>
                                </Row>
                                <Row>
                                    <Col sm={12} className="description" id="modal-producer-description">
                                        <span dangerouslySetInnerHTML={{__html: item.producer.description}}/>
                                        {this.getProducerLink(item)}
                                    </Col>
                                </Row>
                            </div>
                        )
                    })()}
                </div>
                <ItemUnitOrVariants item={this.props.item}
                                    clientViewPort={this.props.clientViewPort}
                                    staticData = {this.props.staticData}
                                    forDetails={true}
                                    schedules={this.getSchedules()}
                                    variantsPubSub={this.props.variantsPubSub}
                                    isJoinFlow = {this.props.isJoinFlow}
                                    isFarmSeasonal={this.props.isFarmSeasonal}
                                    pickupSite={this.props.pickupSite}
                                    bottom={true}
                                    onlyShowQuantityUpdater={true}
                                    shouldShowQuantityUpdater = {this.props.shouldShowQuantityUpdater}/>
            </div>
        )
    };

    getTopDetails = () => {
        return (
            <Row className="top-details">
                <Col sm={3}><img src={this.props.item.imageUrl} onError={setNoItemImage}/></Col>
                {this.props.item.label && <div className="item-label">{this.props.item.label}</div>}
                <Col sm={9} className="details">
                    <div className="item-title" id="modal-item-title">{this.props.item.title}</div>
                    <div className="producer-title" id="modal-producer-title">{this.props.item.producerTitle}</div>
                    <Row className="price-and-buttons">
                        <ItemUnitOrVariants item={this.props.item}
                                            clientViewPort={this.props.clientViewPort}
                                            staticData = {this.props.staticData}
                                            forDetails={true}
                                            schedules={this.getSchedules()}
                                            variantsPubSub={this.props.variantsPubSub}
                                            isJoinFlow = {this.props.isJoinFlow}
                                            isFarmSeasonal={this.props.isFarmSeasonal}
                                            pickupSite={this.props.pickupSite}
                                            shouldShowQuantityUpdater = {this.props.shouldShowQuantityUpdater}/>
                    </Row>
                </Col>
            </Row>
        )
    };

    getBottomDetails = () => {
        const item = this.props.item;
        return(
            <div className="bottom-details">
                <Row>
                    <Col sm={12} className="title">{translate("Product Details")}</Col>
                </Row>
                <Row>
                    <Col sm={12} className="description" id="modal-description" dangerouslySetInnerHTML={{__html: item.description}}/>
                </Row>

                {(() => {
                    if (this.props.staticData.hideProducer) {
                        return null;
                    }
                    if (item.producer.imageUrl && item.producer.imageUrl !== "http://"){
                        return (
                            <div>
                                <Row className="producer">
                                    <Col sm={12} className="title">{translate("About the producer")}</Col>
                                </Row>
                                <Row className="producer-description-row">
                                    <Col sm={3} className="producer-img"><img src={item.producer.imageUrl} onError={setNoItemImage}/></Col>
                                    <Col sm={9} className="description" id="modal-producer-description">
                                        <span dangerouslySetInnerHTML={{__html: item.producer.description}}/>
                                        {this.getProducerLink(item)}
                                    </Col>
                                </Row>
                            </div>
                        )
                    }
                    return (
                        <div>
                            <Row className="producer">
                                <Col sm={12} className="title">{translate("About the producer")}</Col>
                            </Row>
                            <Row>
                                <Col sm={12} className="description" id="modal-producer-description">
                                    <span dangerouslySetInnerHTML={{__html: item.producer.description}}/>
                                    {this.getProducerLink(item)}
                                </Col>
                            </Row>
                        </div>
                    )
                })()}

            </div>
        )
    };

    getSchedules = () => {
        if (this.props.isJoinFlow) {
            return (<JoinScheduleSelector item={this.props.item} schedules={this.props.schedules} isFarmSeasonal= {this.props.isFarmSeasonal}/>);
        }
        return undefined;
    };

    render() {
        return (
            <Modal className="item-details-modal" show={true} onHide={this.props.closeDetails} backdrop={true}>
                <Modal.Body>
                    <div className="item-details">
                        <button id="close-button" className="close-button" onClick={this.props.closeDetails}/>
                        {this.props.clientViewPort && this.props.clientViewPort.isXs ?
                            this.getMobileViewDetails()
                            :
                            <div>
                                {this.getTopDetails()}
                                <hr className="details-divider"/>
                                {this.getBottomDetails()}
                            </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ItemDetails


// WEBPACK FOOTER //
// ./src/components/common/ItemDetails.js